import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Route, withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { ThemeProvider } from '@carvana/showroom-theme';
import { withDocumentTitle } from '@carvana/purchase-helpers';
import { Loading } from '@carvana/purchase-styles';

const ContentWrapper = styled.div`
  padding-bottom: 90px;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Purchase = lazy(() =>
  import(
    /* webpackChunkName: "vehicle-confirmation" */ './components/service-area'
  )
);

const Routes = props => {
  const {
    match: { path }
  } = props;

  return (
    <Suspense fallback={<Loading />}>
      <ThemeProvider>
        <Route
          exact
          path={`${path}/service-area`}
          render={() => (
            <ContentWrapper>
              <Purchase {...props} />
            </ContentWrapper>
          )}
        />

        <Route exact path={path} render={() => null} />
      </ThemeProvider>
    </Suspense>
  );
};

Routes.propTypes = {
  match: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool
};

Routes.defaultProps = {
  isLoading: false
};

export default compose(
  withDocumentTitle('Restricted'),
  withRouter
)(Routes);
